import React from 'react';
import styled from 'styled-components';
import Bubble from './Bubble';

export default styled(({ bubble, color, children, className }) => (
  <div className={className}>
    <Bubble type={bubble} />
    {children}
  </div>
))`
  color: ${({ color }) => color || 'black'};
  font-weight: 500;
`;
